import React, { useEffect } from 'react'
import { useReduxState } from '@/hooks/reduxState'
import LoadingIndicator from '@/components/LoadingIndicator'
import { getStore } from '@/store'
import { push } from 'react-router-redux'
import { isAnonymousLocation } from '@/components/auth/isAnonymousLocation'
import { useLocation } from 'react-router-dom'

function AuthProvider ({ children }) {
  const { signedIn } = useReduxState(state => ({ signedIn: state.identity.signedIn }))
  const location = useLocation()
  const anonymous = isAnonymousLocation(location)
  useEffect(() => {
    if (!anonymous && signedIn === false) {
      redirectWithReturnUrl('/login')
    } else if (signedIn && window.location.pathname === '/login') {
      redirectToReturnUrl()
    }
  }, [signedIn, location, anonymous])

  return <React.Fragment>{ anonymous || signedIn ? children : <LoadingIndicator /> }</React.Fragment>
}

function redirectWithReturnUrl (path) {
  setTimeout(() => {
    if (path === window.location.pathname) return
    const returnUrl = window.location.pathname + window.location.search
    const url = returnUrl !== '/' && returnUrl !== path
      ? `${path}?returnUrl=${encodeURIComponent(returnUrl)}`
      : path
    getStore().dispatch(push(url))
  }, 10)
}

function redirectToReturnUrl () {
  let redirectTo
  try {
    redirectTo = new URLSearchParams(window.location.search).get('returnUrl')
  } catch (e) {
    // Internet destroyer solution
    const result = new RegExp('returnUrl=[^&]+').exec(window.location.href)
    redirectTo = result && result.length > 0
      ? result[0].replace('returnUrl=', '')
      : null
  }
  redirectTo = redirectTo ? decodeURIComponent(redirectTo) : '/'
  getStore().dispatch(push(redirectTo))
}

function isCurrentLocation (path) {
  return equalLocations(window.location.pathname, path)
}

function equalLocations (path1, path2) {
  path1 = normalizePath(path1)
  path2 = normalizePath(path2)
  return path1 === path2
}

function normalizePath (path) {
  return path && path.toLowerCase().replace(/[/ ]+$/g, '')
}

export {
  AuthProvider,
  redirectWithReturnUrl,
  redirectToReturnUrl,
  isCurrentLocation,
  equalLocations
}



// WEBPACK FOOTER //
// ./src/components/auth/authProvider.js